const datasets = [

    {
        'name': 'card',
        'scope': 'demo',
        'source': require('./demo/card2.json'),
        'type': 'dataset'
    }
];

export {datasets};
